export function shouldApplyCustomerDefaults({
  isExistingRecordMode,
  customerChangedByUser,
}) {
  if (customerChangedByUser) return true;
  return !isExistingRecordMode;
}
